import { useState, useEffect } from 'react'

/**
 *
 * @param {promise} fn this is a promise function
 * @param {Array} watch list of variables to watch
 * @param {Fn} fn that returns bool whether or not refresh should be called in useEffect
 * @example
 * function Component() {
 *   const [loading, result, error, refresh] = usePromise(Client.productsIndex)
 *   return <div onClick={refresh}>{loading ? 'loading...' : result.map(d=>d)}</div>
 * }
 */
const usePromise = (fn, watch = [], shouldRefresh = () => true) => {
  const [loading, setLoading] = useState(true)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  const refresh = async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await fn()
      setResult(res)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (shouldRefresh()) refresh()
  }, watch)

  return [loading, result, error, refresh]
}

export default usePromise
